/* MIMOS · Viaje — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('mt-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('mt-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contar]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, fin = parseFloat(el.getAttribute('data-mt-contar')) || 0;
        var pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '';
        if (reduce) { el.textContent = pre + fin + suf; return; }
        var t0 = null, dur = 1600;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + Math.round(fin * e) + suf;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect(), k = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        el.style.setProperty('--mt-parallax', (-centro * k / 100).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function initTilt() {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-mt-tilt]').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(800px) rotateX(' + (-y * 6) + 'deg) rotateY(' + (x * 6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  function initEscenas() {
    document.querySelectorAll('[data-mt-escena]').forEach(function (esc) {
      var pasos = esc.querySelectorAll('.mt-paso'), imgs = esc.querySelectorAll('.mt-escena__marco img');
      if (!pasos.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = parseInt(en.target.getAttribute('data-i'), 10);
          pasos.forEach(function (p, j) { p.classList.toggle('is-activo', j === i); });
          imgs.forEach(function (im, j) { im.classList.toggle('is-activa', j === i); });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  function initMenuMovil() {
    document.querySelectorAll('[data-mt-menu-abrir]').forEach(function (b) {
      var menu = document.getElementById(b.getAttribute('aria-controls'));
      if (!menu) return;
      b.addEventListener('click', function () { menu.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; });
      menu.querySelectorAll('[data-mt-menu-cerrar], a').forEach(function (c) {
        c.addEventListener('click', function () { menu.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; });
      });
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      // Galería
      var principal = root.querySelector('.mt-galeria__principal img');
      var minis = Array.prototype.slice.call(root.querySelectorAll('.mt-galeria__mini'));
      var idx = 0;
      function mostrar(i) {
        if (!minis.length || !principal) return;
        idx = (i + minis.length) % minis.length;
        var m = minis[idx];
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = m.getAttribute('data-src');
          principal.srcset = m.getAttribute('data-srcset') || '';
          principal.alt = m.getAttribute('data-alt') || '';
          principal.style.opacity = '1';
        }, 160);
        minis.forEach(function (x, j) { x.classList.toggle('is-activa', j === idx); });
      }
      minis.forEach(function (m, j) { m.addEventListener('click', function () { mostrar(j); }); });
      var prev = root.querySelector('.mt-galeria__flecha--prev'), next = root.querySelector('.mt-galeria__flecha--next');
      if (prev) prev.addEventListener('click', function () { mostrar(idx - 1); });
      if (next) next.addEventListener('click', function () { mostrar(idx + 1); });

      // Variantes
      var dataEl = root.querySelector('[data-mt-variantes]');
      var form = root.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = root.querySelector('[data-mt-boton]');
      var precio = root.querySelectorAll('[data-mt-precio]');
      var tachado = root.querySelectorAll('[data-mt-tachado]');
      var ahorro = root.querySelector('[data-mt-ahorro]');
      var etiquetas = root.querySelectorAll('[data-mt-valor-opcion]');
      var formato = root.getAttribute('data-money-format') || '${{amount}}';
      var txtAgotado = root.getAttribute('data-txt-agotado') || 'Agotado';
      var txtBoton = boton ? boton.getAttribute('data-txt') : '';

      function money(cents) {
        var n = (cents / 100);
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
          var dec = /no_decimals|amount_no_decimals/.test(k) ? 0 : 2;
          var s = n.toFixed(dec).split('.');
          var miles = /comma_separator/.test(k) ? '.' : (/apostrophe/.test(k) ? "'" : (/space_separator/.test(k) ? ' ' : ','));
          var decSep = /comma_separator/.test(k) ? ',' : '.';
          s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
          return s.join(decSep);
        });
      }

      function actualizar() {
        if (!dataEl) return;
        var variantes = JSON.parse(dataEl.textContent);
        var sel = [];
        root.querySelectorAll('.mt-opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        etiquetas.forEach(function (e) { var i = parseInt(e.getAttribute('data-mt-valor-opcion'), 10); e.textContent = sel[i] || ''; });
        if (!v) { if (boton) { boton.disabled = true; boton.querySelector('span').textContent = 'No disponible'; } return; }
        if (inputId) inputId.value = v.id;
        precio.forEach(function (p) { p.textContent = money(v.price); });
        var hayTachado = v.compare_at_price && v.compare_at_price > v.price;
        tachado.forEach(function (t) { t.textContent = hayTachado ? money(v.compare_at_price) : ''; t.style.display = hayTachado ? '' : 'none'; });
        if (ahorro) { ahorro.style.display = hayTachado ? '' : 'none'; if (hayTachado) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? txtBoton : txtAgotado; }
        if (v.featured_media && v.featured_media.id) {
          var j = minis.findIndex(function (m) { return m.getAttribute('data-media-id') == v.featured_media.id; });
          if (j > -1) mostrar(j);
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('.mt-opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

      // Cantidad
      var qty = root.querySelector('.mt-cantidad input');
      root.querySelectorAll('[data-mt-qty]').forEach(function (b) {
        b.addEventListener('click', function () { var v = parseInt(qty.value, 10) || 1; v += parseInt(b.getAttribute('data-mt-qty'), 10); qty.value = Math.max(1, v); });
      });

      // Añadir al carrito con el cajón de Dawn (si existe); si no, envío normal
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function') return;
          e.preventDefault();
          var err = root.querySelector('.mt-compra__error');
          if (boton) boton.setAttribute('aria-busy', 'true');
          var fd = new FormData(form);
          fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) { if (err) { err.textContent = res.description || res.message; err.style.display = 'block'; } return; }
              if (err) err.style.display = 'none';
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
        });
      }

      // Barra de compra fija
      var barra = document.querySelector('[data-mt-barra]');
      var zona = root.querySelector('.mt-compra__fila');
      if (barra && zona && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0]; barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(zona);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () { if (boton && !boton.disabled) boton.click(); else zona.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      }
    });
  }


  function initComparadores() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (c) {
      var r = c.querySelector('.mt-ad__rango'); if (!r || r.dataset.ok) return; r.dataset.ok = '1';
      r.addEventListener('input', function () { c.style.setProperty('--mt-pos', r.value + '%'); });
    });
  }

  function initTodo() { initReveals(); initContadores(); initParallax(); initTilt(); initEscenas(); initMenuMovil(); initProducto(); initComparadores(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', function () { initReveals(); initContadores(); initParallax(); initTilt(); initEscenas(); initMenuMovil(); initProducto(); initComparadores(); });
})();
